/**
 * 科技人才相关 API
 */
import request from '@/utils/request'
import baseUrl from '@/utils/baseUrl'

const techTalentApi = {}

/**
 * 获取人才列表（分页）
 * @param {Object} params 查询参数
 * @param {Number} params.pageNum 页数
 * @param {Number} params.pageSize 条数
 * @param {String} params.mailingCommunications 省份
 * @param {String} params.field 领域
 * @param {String} params.type 人才类型
 * @param {String} params.name 人名（模糊搜索）
 * @returns {Promise} 返回人才列表数据
 */
techTalentApi.getExpertPageList = function(params = {}) {
  return request({
    url: '/expert/open/page',
    method: 'post',
    data: {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 12,
      mailingCommunications: params.mailingCommunications || '',
      field: params.field || '',
      type: params.type || '',
      name: params.name || ''
    },
    baseURL: baseUrl.expert,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 获取人才详情
 * @param {String} id 人才ID
 * @returns {Promise} 返回人才详情数据
 */
techTalentApi.getExpertDetail = function(id) {
  return request({
    url: '/expert/open/get',
    method: 'post',
    data: {
      id: id
    },
    baseURL: baseUrl.expert,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 人才推荐
 * @param {Number} pageNum 页数
 * @param {Number} pageSize 条数
 * @param {String|Number} [id] 当前人才详情 ID
 * @returns {Promise} 推荐人才列表
 */
techTalentApi.getExpertRecommend = function(pageNum = 1, pageSize = 6, id) {
  const data = {
    pageNum: pageNum,
    pageSize: pageSize
  }
  if (id != null && id !== '') data.id = id
  return request({
    url: '/expert/open/recommend',
    method: 'post',
    data,
    baseURL: baseUrl.expert,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 人才已转化成果列表
 * GET matcher-api /portal/match/getTecList
 * @param {String} id 人才对应的用户id（必填）
 */
techTalentApi.getConvertedTecList = function(id) {
  return request({
    url: '/portal/match/getTecList',
    method: 'get',
    params: {
      id: id || ''
    },
    baseURL: baseUrl.matcher,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export default techTalentApi
